import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import App from './containers/App';
import Main from './components/Main';
import ReviewAggregator from './components/ReviewAggregator';
import Signin from './components/Signin/Signin';
import Register from './components/Register/Register';
import Profile from './components/Profile';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import EditProfile from './components/EditProfile';
import DeleteProfile from './components/DeleteProfile';
import Reported from './components/Reported';
import Rank from './components/Rank';
import Dimes from './components/Dimes';
import UserDimes from './components/UserDimes';
import AddDime from './components/AddDime';
import ReportedDime from './components/ReportedDime';
import PrivacyPolicy from './components/PrivacyPolicy';
import Disclaimer from './components/Disclaimer';
import Terms from './components/Terms';
import AboutPage from './components/AboutPage'; 
import SupportPage from './components/SupportPage'; 
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { searchRobots, requestRobots } from './reducers';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

const logger = createLogger();

const rootReducer = combineReducers({ searchRobots, requestRobots });

const store = createStore(rootReducer, applyMiddleware(thunkMiddleware, logger));

function Root() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={App} />
        <Route path="/about" component={AboutPage} /> 
        <Route path="/support" component={SupportPage} /> 
        <Route path="/home" component={App} />
        <Route path="/signin" component={Signin} />
        <Route path="/register" component={Register} />
        <Route path="/forgotpassword" component={ForgotPassword} />
        <Route path="/resetpassword" component={ResetPassword} />
        <Route path="/Main" component={Main} />
        <Route path="/ReviewAggregator" component={ReviewAggregator} />
        <Route path="/profile" component={Profile} />
        <Route path="/EditProfile" component={EditProfile} />
        <Route path="/DeleteProfile" component={DeleteProfile} />
        <Route path="/Reported" component={Reported} />
        <Route path="/rank" component={Rank} />
        <Route path="/Dimes" component={Dimes} />
        <Route path="/UserDimes" component={UserDimes} />
        <Route path="/AddDime" component={AddDime} />
        <Route path="/ReportedDime" component={ReportedDime} />
        <Route path="/ReportedDime" component={ReportedDime} />
        <Route path="/privacypolicy" component={PrivacyPolicy} />
        <Route path="/disclaimer" component={Disclaimer} />
        <Route path="/terms" component={Terms} />
      </Switch>
    </Router>
  );
}

// React 17 way (no createRoot needed)
ReactDOM.render(
  <Provider store={store}>
    <Root/>
  </Provider>,
  document.getElementById('root')
);